/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react'
import { TPageProps } from 'App/util/appRoutes'

export enum EViewPort {
  mobile,
  desktop,
}

export type TApplicationContext = {
  name: string
  logoBase64: string
  logoMimeType: string
  pages: TPageProps[]
  viewPort: EViewPort
  navigationCollapsed: boolean
  showTenantSwitch: boolean
  showBreadcrumb: boolean
  extraQueryParams?: Record<string, any>,
  extraTokenParams?: Record<string, any>,
  setViewPort: (vp: EViewPort) => void
  toggleNavigationCollapsed: () => void
}

export type TApplicationContextProps = {
  name: string
  logoBase64: string
  logoMimeType: string
  children: any
  pages: TPageProps[]
  extraQueryParams?: Record<string, any>,
  extraTokenParams?: Record<string, any>,
  hideTenantSwitch?: boolean
  showBreadcrumb?: boolean
}

export const ApplicationContext = React.createContext<TApplicationContext>({
  name: 'Accall/io App',
  logoBase64: '',
  logoMimeType: '',
  pages: [],
  viewPort: EViewPort.desktop,
  navigationCollapsed: false,
  showTenantSwitch: true,
  showBreadcrumb: true,
  setViewPort: (vp) => { },
  toggleNavigationCollapsed: () => { },
})

export default ({ children, pages, name, logoBase64, logoMimeType, extraQueryParams, extraTokenParams, showBreadcrumb = true, hideTenantSwitch = false }: TApplicationContextProps) => {
  const [viewPort, setViewPort] = useState<EViewPort>(EViewPort.desktop)
  const [navigationCollapsed, setNavigationCollapsed] = useState<boolean>(false)

  const toggleNavigationCollapsed = () => {
    if (viewPort === EViewPort.desktop) {
      setNavigationCollapsed(false)
    } else {
      setNavigationCollapsed(!navigationCollapsed)
    }
  }

  useEffect(() => {
    if (viewPort === EViewPort.desktop) {
      setNavigationCollapsed(false)
    } else {
      setNavigationCollapsed(true)
    }
  }, [viewPort])

  const value: TApplicationContext = {
    name,
    logoBase64,
    logoMimeType,
    pages,
    viewPort,
    navigationCollapsed,
    showTenantSwitch: !hideTenantSwitch,
    showBreadcrumb,
    extraQueryParams,
    extraTokenParams,
    setViewPort,
    toggleNavigationCollapsed,
  }

  return <ApplicationContext.Provider value={value}>{children}</ApplicationContext.Provider>
}
